import React from 'react';

import classNames from 'classnames';

import { InputErrorText } from '@travauxlib/shared/src/components/DesignSystem/components/Input/commons';

import CheckSymbol from '../../assets/CheckSymbolFilled.svg?react';
import MinusSymbol from '../../assets/MinusSymbol.svg?react';
import {
  commonFormControlCheckmarkClasses,
  commonFormControlContainerClasses,
  GenericFormControlContainer,
} from '../FormControl/commons';

import type { FormControlProps } from '../FormControl/commons';

export type Props = FormControlProps<boolean> & {
  error?: string;
  checked: boolean;
  small?: boolean;
};

export const Checkbox: React.FC<Props> = ({
  className,
  label,
  checked,
  disabled,
  onChange,
  error,
  indeterminate,
  small,
  ...rest
}) => {
  const checkmarkSize = small ? 'size-md' : 'size-xmd';
  const CheckmarkIcon = indeterminate ? MinusSymbol : CheckSymbol;

  return (
    <>
      <GenericFormControlContainer
        height={18}
        width={18}
        onChange={e => onChange?.(e.target.checked)}
        type="checkbox"
        label={label}
        className={className}
        checked={checked}
        disabled={disabled}
        {...rest}
      >
        <span
          className={classNames(
            'rounded-xxs inline-flex shrink-0',
            commonFormControlContainerClasses(checked, disabled, !!error),
            commonFormControlCheckmarkClasses(checked, disabled, indeterminate),
          )}
          aria-hidden
        >
          {indeterminate || checked ? (
            <CheckmarkIcon className={checkmarkSize} fill="white" />
          ) : (
            <div className={checkmarkSize} />
          )}
        </span>
      </GenericFormControlContainer>
      <InputErrorText error={error} />
    </>
  );
};
